import { deleteRecord } from '@/entities/shared/record/delete-record';

export async function deleteNote(id: string): Promise<void> {
  await deleteRecord('notes', id);
}
